import { APP_NAV } from '../nav'
import { Shell } from './Shell'

/** Powłoka aplikacji HR (`/app/*`) — spec 01 §0.1–0.2. */
export function AppShell() {
  return (
    <Shell
      navNamespace="nav"
      items={APP_NAV}
      contextSwitch={{ to: '/me', labelKey: 'shell.toPortal' }}
      fallbackMetaKey="dashboard"
      assistantScope="app"
    />
  )
}
